import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import CodeEditor from "../../primitives/CodeEditor";

/**
 * Modal for configuring field modifiers
 */
const ModifierModal = ({ open, onClose, onSubmit, modalState, onStateChange }) => {
  const { modifier } = modalState;

  const handleSubmit = () => {
    if (modifier.trim()) {
      onSubmit();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Configure Field Modifier</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            Write a JavaScript function to transform the field value. The function receives the
            field value as the first parameter and the complete source object as the second
            parameter.
          </Typography>

          <CodeEditor
            value={modifier}
            onChange={(e) => onStateChange("modifier", e.target.value)}
            placeholder="(value, source) => {
              // Transform the value here
              return value;
            }"
            label="JavaScript Modifier Function"
            helperText="Example: (value) => value?.toUpperCase() || (value, source) => source.country === 'US' ? value.replace(/\D/g, '') : value"
            height="200px"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={!modifier.trim()}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModifierModal;
